export const scheduleAssistantTranslationsEn = {
  capacityInputNeededText: 'Input needed to track capacity',
  capacityTitle: 'Capacity',
  noCollisionsText: 'No collisions *',
  settingsPeakDescription: 'Peaks are the highest number of personnel on site of any given day.',
  settingsPeakTitle: 'Peak',
  settingsSiteTitle: 'Site',
  settingsThresholdDescription:
    'Thresholds define the maximum personnel availability. You will receive a collision notification if this number is exceeded.',
  settingsThresholdTitle: 'Threshold',
  settingsTitle: 'Settings',
  statusText: 'Current status',
  title: 'Schedule Assistant',
};
